/**
 * HouseHandoffPanel (PROPERTY-LINK-01, Seth 2026-10-16) — the morning a new ESC
 * account lands at an address Sedgwick already knows (the builder's job site,
 * the previous owner's home), the office answers one question and the house
 * becomes one record: the new owner's 360 and the tech's iPad read every era.
 * Lives in Today's Service queue; hides itself when there's nothing to answer.
 * The full backlog (every unanswered pair, no date limit) is Settings → Addresses.
 */
import { Home } from "lucide-react";
import { Card } from "@/components/ui/Card";
import { useHouseReviewList } from "@/features/customer-360/houseHistory";
import { HouseLinkPrompt } from "@/features/customer-360/HouseLinkPrompt";

const RECENT_DAYS = 45;

/** The rows the panel renders — the Service tab counts the same list. */
export function useHouseHandoffs() {
  return useHouseReviewList(RECENT_DAYS, 50);
}

export function HouseHandoffPanel() {
  const { data, isLoading } = useHouseHandoffs();
  const rows = data ?? [];
  if (isLoading || rows.length === 0) return null; // quiet section hides itself
  return (
    <Card className="p-4">
      <div className="mb-3 flex items-center gap-2">
        <Home className="h-4 w-4 text-amber-600" />
        <h3 className="text-sm font-semibold text-slate-900">New accounts at known addresses</h3>
        <span className="text-xs text-slate-400">{rows.length} to answer</span>
      </div>
      <div className="space-y-2">
        {rows.map((r) => (
          <HouseLinkPrompt key={`${r.custno}/${r.locno ?? ""}→${r.other_custno}`} row={r} />
        ))}
      </div>
    </Card>
  );
}
